<div class="faq-component">
  <app-top-header
    [parent]="parentInfo"
    class="admin-header-container"
  ></app-top-header>

  <app-header-and-description
    heading="TRANS__FAQ__TITLE"
    description="TRANS__FAQ__INGRESS"
    href="support@kulturit.no"
  >
    <ul class="content">
      @for (category of res; track $index) {
        <li class="category">
          <a
            class="category__items"
            (click)="toggleCategory(category)"
          >
            <mat-icon
              [class.text-primary]="category.selected"
              class="category__arrow"
            >
              {{category.selected ? 'expand_more' : 'chevron_right'}}
            </mat-icon>

            <span
              class="category__title"
              [class.text-primary]="category.selected"
            >
              {{category[AConst.CATEGORY_TITLE]}}
            </span>
          </a>

          @if (category.selected) {
            <ul class="faqs">
              @for (fq of category[AConst.FAQ]; track $index) {
                <li
                  [attr.data-index]="$index"
                  class="faqs__items"
                  (click)="toggleFq(fq)"
                  (keydown)="null"
                >
                  <mat-icon
                    [class.text-primary]="fq.selected"
                    class="faqs__arrow"
                  >
                    {{fq.selected ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>

                  <div class="faqs__vertical-line-container">
                    @if (fq.selected) {
                      <div class="faqs__vertical-line bg-blue"></div>
                    }
                  </div>

                  <div class="faqs__content">
                    <span
                      class="faqs__question"
                      [class.text-primary]="fq.selected"
                    >
                      {{ fq.question | translate }}
                    </span>

                    @if (fq.selected) {
                      <div class="faqs__answer">
                        <span [translate]="fq[AConst.ANSWER]">
                          {{ fq[AConst.ANSWER] | translate}}
                        </span>

                        @if (fq.url) {
                          <a
                            class="link text-primary"
                            target="_blank"
                            [href]="fq.url"
                          >
                            {{fq.url}}
                          </a>
                        }
                      </div>
                    }
                  </div>
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  </app-header-and-description>
</div>

